(function(window, document) {
  'use strict';

  if (window.StefanBooking) return;

  var SERVICES_URL = 'https://stefan.zenoti.com/webstoreNew/services/';
  var STORAGE_KEYS = {
    key: 'stefan_selected_salon',
    label: 'stefan_selected_salon_label',
    locationId: 'stefan_selected_salon_location_id'
  };

  function clean(value) {
    return String(value == null ? '' : value).trim();
  }

  function readStorage(key) {
    try {
      return clean(window.localStorage.getItem(key));
    } catch (error) {
      return '';
    }
  }

  function writeStorage(key, value) {
    try {
      window.localStorage.setItem(key, clean(value));
    } catch (error) {
      // Booking links still work for this page even if storage is unavailable.
    }
  }

  function getSalon() {
    return {
      key: readStorage(STORAGE_KEYS.key),
      label: readStorage(STORAGE_KEYS.label),
      locationId: readStorage(STORAGE_KEYS.locationId)
    };
  }

  function setSalon(salon) {
    salon = salon || {};

    var selected = {
      key: clean(salon.key),
      label: clean(salon.label),
      locationId: clean(salon.locationId)
    };

    writeStorage(STORAGE_KEYS.key, selected.key);
    writeStorage(STORAGE_KEYS.label, selected.label);
    writeStorage(STORAGE_KEYS.locationId, selected.locationId);

    updateLinks(document);

    document.dispatchEvent(new CustomEvent('stefan:salon:changed', {
      detail: { salon: selected }
    }));

    return selected;
  }

  /**
   * Builds the Zenoti URL used everywhere on the storefront.
   * With a package ID: /services/{LOCATION_ID}?serviceid={PACKAGE_ID}
   * Without one:       /services/{LOCATION_ID}
   */
  function buildUrl(locationId, packageId) {
    locationId = clean(locationId);
    packageId = clean(packageId);

    if (!locationId) return '';

    var url = SERVICES_URL + encodeURIComponent(locationId);
    if (packageId) url += '?serviceid=' + encodeURIComponent(packageId);

    return url;
  }

  function getBookingUrl(link, salon) {
    if (!link) return '';

    salon = salon || getSalon();
    return buildUrl(salon.locationId, link.getAttribute('data-package-id'));
  }

  function updateLinks(scope) {
    var container = scope && scope.querySelectorAll ? scope : document;
    var salon = getSalon();

    container.querySelectorAll('[data-book-now]').forEach(function(link) {
      link.setAttribute('href', getBookingUrl(link, salon) || '#');
    });
  }

  document.addEventListener('click', function(event) {
    var link = event.target.closest('[data-book-now]');
    if (!link) return;

    var salon = getSalon();
    var bookingUrl = getBookingUrl(link, salon);

    if (!bookingUrl) {
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('stefan:booking:salon-required', {
        detail: { link: link }
      }));
      return;
    }

    link.setAttribute('href', bookingUrl);
  });

  window.StefanBooking = {
    buildUrl: buildUrl,
    getBookingUrl: getBookingUrl,
    getSalon: getSalon,
    setSalon: setSalon,
    updateLinks: updateLinks
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      updateLinks(document);
    }, { once: true });
  } else {
    updateLinks(document);
  }
})(window, document);
